<template>
  <Moveable
    ref="handler"
    class="draggable-signature"
    v-bind="moveable"
    :style="style"
    @drag="handleDrag"
    @drag-end="handleDragEnd"
  >
    <OfficeSignature
      :meta="meta"
      :closable="closable"
      @close="$emit('close')"
    />
  </Moveable>
</template>

<script>

import Moveable from 'vue-moveable';

import OfficeSignature from '@/febos/global/pdf/components/OfficeSignature';
import DraggableSignatureBehaviors from '@/febos/global/pdf/mixins/DraggableSignatureBehaviors';

export default {
  mixins: [DraggableSignatureBehaviors],
  components: {
    Moveable,
    OfficeSignature
  },
  props: {
    meta: { type: Object, required: true },
    closable: { type: Boolean, default: true }
  }
};

</script>
